import React, { useState, useEffect } from "react";
import {
    Box, Typography, Button, TextField, InputAdornment, Divider, Modal, ToggleButton, ToggleButtonGroup, Skeleton, Menu, MenuItem, RadioGroup, FormControlLabel, Radio,
} from "@mui/material";
import { useOutletContext, } from "react-router-dom";
import { useSelector } from "react-redux";
import { esignIcons } from "../../components/Esign/icons";
import StampPaperTable from "./Components/StampPaperTable";
import Loader from "../../components/Loader";
import { esignToolApi } from "../../services/esignApi";
import StatusCardsExample from "./Components/StatusCard";

const Stampapers = () => {
    const { open } = useOutletContext();
    const [stampPapersTableData, setStampPapersTableData] = useState([])
    const [stampPapersTotal, setStampPapersTotal] = useState(null)
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalEntries, setTotalEntries] = useState(0);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [page, setPage] = useState(0);
    const [tableloader, setTableLoader] = useState(false);
    const [filter, setFilter] = useState(false);
    const [status, setStatus] = useState('all');
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [sortOption, setSortOption] = useState("latest");
    const [filterOption, setFilterOption] = useState("all");

        const fetchAllStampPapers = async () => {
                setTableLoader(true)
                try {
                    const response = await esignToolApi.fetchStampPapers(searchText, page, rowsPerPage, filterOption === 'all' ? undefined : filterOption);
                    setTableLoader(false)
                    console.log(response)
                    if (response?.results?.status) {
                        console.log(response);
                        setStampPapersTableData(response?.results?.stamps);
                        setStampPapersTotal(response?.results?.summary);
                        setTotalEntries(response.count);
                    }
                } catch (error) {
                        setTableLoader(false)
                        console.error("Error fetching data:", error);
                        setStampPapersTableData([]);
                        setStampPapersTotal(null);
                }
        };

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            fetchAllStampPapers();
        }, 500);

        return () => clearTimeout(delayDebounce);
    }, [searchText, page, rowsPerPage]);


    const handleStatusChange = (event, newStatus) => {
        if (newStatus !== null) setStatus(newStatus);
    };

    const handleMenuOpen = (event, doc) => {
        setMenuAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
    };

    return (
      <Box
        sx={{
          flexGrow: 1,
          p: 3,
          width: open ? "calc(100% - 240px)" : "calc(100% - 100px)",
          marginLeft: open ? "240px" : "100px",
          transition: "margin 0.3s ease",
          height: "100vh",
          display: "flex",
          background: "#f9f9f9",
        }}
      >
        <Box
          mt={10}
          style={{
            borderRadius: "12px",
            textAlign: "center",
            background: "#fff",
            width: "100%",
            height: stampPapersTableData.length >= 0 ? "calc(100% - 73px)" : "calc(100% - 127px)",
            marginLeft: open ? "" : "1em",
          }}
        >
            <Box sx={{ display: "flex", alignItems:'center', justifyContent: "space-between", padding: "15px 21px" }}>
                <Typography noWrap component="p" sx={{ fontSize: '20px', fontWeight: 500, lineHeight: '20px', color: "#1D1D1D",  paddingBottom: "2px" }}>
                    Stamp Papers
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: "20px" }}>
                    <TextField
                        placeholder="Search..."
                        variant="outlined"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        sx={{
                        boxSizing: "border-box",
                        borderRadius: "10px",
                        backgroundColor: "#fff",
                        borderColor: "#E8E8E9",
                        borderWidth: "5px",
                        "& .MuiOutlinedInput-root": {
                            borderColor: "#E8E8E9",
                            backgroundColor: "none",
                            "&:hover fieldset": {
                            borderColor: "#E8E8E9",
                            },
                            "&.Mui-focused fieldset": {
                            borderColor: "#E8E8E9",
                            },
                        },
                        }}
                        InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                            {esignIcons.searchIcon}
                            </InputAdornment>
                        ),
                        sx: { 
                            borderRadius: "10px",
                            width: 410,
                            height: 40,
                            fontSize: "16px",
                            fontWeight: "500",
                            "& input::-ms-reveal, & input::-ms-clear": {
                                display: "none",
                            },
                            "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                                display: "none",
                                WebkitAppearance: "none",
                                margin: 0,
                            },
                            "& input[type=number]": {
                                MozAppearance: "textfield",
                            },
                        },
                        }}
                    />
                    <Button variant="contained" sx={{ minWidth: 115, height: 42, background: "#FFFFFF", color: "#1D1D1D", borderRadius: "8px", border: "1px solid #E8E8E9", boxShadow: "none", p:0, display: "flex", alignItems: "center", gap: "12px", textTransform: "capitalize", fontSize: "14px", fontWeight: "500", justifyContent: "space-evenly",  "&:disabled": { background: "#fff", color: "#1D1D1D", opacity: "0.5"} }} onClick={(e) => handleMenuOpen(e)} disabled={stampPapersTableData.length <= 0} >
                        <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>{esignIcons.filterIcon} Filters</span> <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L9 1" stroke="#1D1D1D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>

                    </Button> 
                    { stampPapersTableData.length > 0 && (<Button variant="contained" sx={{ minWidth: '152px', height: 40, color: "#ffffff", background: "#185CB7", textTransform: "none", fontSize: "14px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "500", display: "flex", p: "9px 11px", justifyContent: "space-between", alignItems: "center", gap: "4px" }} onClick={() => {setPreviewOpen(true);}} >
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.35938 9.16675C5.72602 9.17143 5.34491 9.19084 5.04134 9.27122C3.65972 9.63706 2.71382 10.8753 2.75106 12.2694C2.76185 12.6732 2.91556 13.1722 3.223 14.1704C3.96287 16.5725 5.20633 18.6578 7.99191 19.1581C8.50395 19.2501 9.08014 19.2501 10.2325 19.2501L11.7675 19.2501C12.9199 19.2501 13.496 19.2501 14.0081 19.1581C16.7937 18.6578 18.0371 16.5725 18.777 14.1704C19.0844 13.1722 19.2382 12.6732 19.2489 12.2694C19.2862 10.8753 18.3403 9.63706 16.9587 9.27122C16.6551 9.19084 16.274 9.17143 15.6406 9.16675" stroke="white" stroke-width="1.55833" stroke-linecap="round"/>
                        <path d="M11 2.74992L11 12.8333M11 2.74992C11.4293 2.74992 11.7557 3.15151 12.4084 3.95469L13.2916 5.04159M11 2.74992C10.5706 2.74992 10.2443 3.15151 9.59155 3.9547L8.70829 5.04159" stroke="white" stroke-width="1.55833" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        Upload Stamp
                    </Button>)}
                </Box>
            </Box>

            <Menu
                anchorEl={menuAnchorEl}
                open={Boolean(menuAnchorEl)}
                onClose={handleMenuClose}
                slotProps={{
                    backdrop: {
                    sx: {
                        backgroundColor: "rgba(0,0,0,0.1)",  // black transparent
                    },
                    },
                }}
                BackdropProps={{ invisible: false }}
                PaperProps={{
                    sx: {
                        height: "295px",
                        width: "240px",
                        borderRadius: "10px",
                        display: "flex",
                        flexDirection: "column",
                        // justifyContent: "space-evenly",
                        overflow: "hidden",
                        // alignItems: "center",
                        padding: "20px 15px",
                        mt: 1,
                    },
                }}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right", 
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                MenuListProps={{
                    sx: {
                    padding: 0,
                    margin: 0,
                    },
                }}
            >
                <Box sx={{ flex: 1 }}>
                    {/* <Box>
                        <Typography variant="p" sx={{fontSize: "13px", fontWeight: 400, color: "#1D1D1D", }}>Sort by</Typography>
                        <RadioGroup
                            value={sortOption}
                            onChange={(e) => setSortOption(e.target.value)}
                            sx={{ gap: "4px" }}
                            >
                            <FormControlLabel
                                value="latest"
                                control={<Radio size="small" />}
                                label="Latest"
                                sx={{
                                    "& .MuiFormControlLabel-label": {
                                        fontSize: "13px",
                                        color: "#5C5C5C",
                                        fontWeight: 400,
                                    },
                                }}
                            />
                            <Divider sx={{ width: "88%", alignSelf: "flex-end" }} />
                            <FormControlLabel
                                value="earliest"
                                control={<Radio size="small" />}
                                label="Earliest"
                                sx={{
                                    "& .MuiFormControlLabel-label": {
                                        fontSize: "13px",
                                        color: "#5C5C5C",
                                        fontWeight: 400,
                                    },
                                }}
                            />
                        </RadioGroup>
                    </Box> */}
                    <Box sx={{ mt: "5px" }}>
                        <Typography variant="p" sx={{fontSize: "13px", fontWeight: 400, color: "#1D1D1D", }}>Filter by</Typography>
                        <RadioGroup
                            value={filterOption}
                            onChange={(e) => setFilterOption(e.target.value)}
                            sx={{ gap: "4px" }}
                            >
                            <FormControlLabel
                                value="all"
                                control={<Radio size="small" />}
                                label="All"
                                sx={{
                                    "& .MuiFormControlLabel-label": {
                                        fontSize: "13px",
                                        color: "#5C5C5C",
                                        fontWeight: 400,
                                    },
                                }}
                            />
                            <Divider sx={{ width: "88%", alignSelf: "flex-end" }} />
                            <FormControlLabel
                                value="assigned"
                                control={<Radio size="small" />}
                                label="Assigned"
                                sx={{
                                    "& .MuiFormControlLabel-label": {
                                        fontSize: "13px",
                                        color: "#5C5C5C",
                                        fontWeight: 400,
                                    },
                                }}
                            />
                            <Divider sx={{ width: "88%", alignSelf: "flex-end" }} />
                            <FormControlLabel
                                value="used"
                                control={<Radio size="small" />}
                                label="Used"
                                sx={{
                                    "& .MuiFormControlLabel-label": {
                                        fontSize: "13px",
                                        color: "#5C5C5C",
                                        fontWeight: 400,
                                    },
                                }}
                            />
                            <Divider sx={{ width: "88%", alignSelf: "flex-end" }} />
                            <FormControlLabel
                                value="unused"
                                control={<Radio size="small" />}
                                label="Unused"
                                sx={{
                                    "& .MuiFormControlLabel-label": {
                                        fontSize: "13px",
                                        color: "#5C5C5C",
                                        fontWeight: 400,
                                    },
                                }}
                            />
                        </RadioGroup>
                    </Box>
                </Box>
                <Box sx={{ position: "relative", bottom: "-10px" }}>
                    <Button variant="contained" sx={{ width: '100%', height: 40, color: "#ffffff", background: "#185CB7", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "500", }} onClick={() => { handleMenuClose(); fetchAllStampPapers(); }}  >
                        Apply
                    </Button>
                </Box>
            </Menu>

            <StatusCardsExample totalStamps={stampPapersTotal?.total_stamps || 0} usedStamps={stampPapersTotal?.used_stamps || 0} leftStamps={stampPapersTotal?.left_stamps || 0} />
            <Divider />
            <StampPaperTable filteredDocs={stampPapersTableData} fetchAllStampPapers={fetchAllStampPapers} setPreviewOpen={setPreviewOpen} previewOpen={previewOpen} page={page} setPage={setPage} rowsPerPage={rowsPerPage} setRowsPerPage={setRowsPerPage} totalEntries={totalEntries} tableloader={tableloader} setTableLoader={setTableLoader} />
            {/* {loader && <Loader />} */}
        </Box>
      </Box>
    );
};

const toggleStyle = (selected) => ({
  borderRadius: "10px !important",
  textTransform: "none",
  fontSize: "16px",
  fontWeight: "500",
  color: selected ? "#185CB7" : "#1D1D1D",
  backgroundColor: selected ? "#E6F1FF !important" : "#ffffff !important",
  border: selected ? "1px solid #CCE2FE !important" : "1px solid #D2D2D2 !important",
  minWidth: "70px",
  height: "46px",
  boxShadow: "none",
  '&.Mui-selected': {
    backgroundColor: "#E6F1FF",
    color: "#185CB7",
    border: "1px solid #CCE2FE",
  },
  '&:hover': {
    backgroundColor: "#E6F1FF",
  }
});

export default Stampapers;
